import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { useSelect } from '../../../../../utils/selector.utils';
import { closeDialog, openDialog } from '../../../../../app/dialog/dialog.actions';
import { changePassword } from '../../../../../app/page/page-storage/users/users.actions';
import Loader from 'react-loader-spinner';
import { useApiRequestState } from '../../../../../utils/api.utils';
const PASSWORD_REGEX = /^.{8,}$/;

export const Security = () => {
  const userId = useSelect(authSelectors.selectLoggedUser) || '';
  const [isPasswordChangeLoading, passwordChangeError] = useApiRequestState('changePasswordUserSettings');

  //const [twoFactorAuth, setTwoFactorAuth] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmedPassword, setConfirmedPassword] = useState('');
  const [errorText, setErrorText] = useState('');
  const [isPasswordChangeSuccess, setPasswordChangeSuccess] = useState(false);

  const dispatch = useDispatch();

  const handleChangePassword = () => {
    dispatch(
      openDialog('confirmation', {
        title: 'Change password',
        message: 'Are you sure you want to change your password?',
        cancelButton: 'cancel',
        confirmButton: 'confirm',
        onConfirm: () => {
          dispatch(changePassword(password));
          dispatch(closeDialog('confirmation'));
        },
      }),
    );
  };

  useEffect(() => {
    setErrorText('');

    if (!passwordChangeError && isPasswordChangeLoading) {
      setPassword('');
      setConfirmedPassword('');
      setPasswordChangeSuccess(true);
      setTimeout(() => {
        setPasswordChangeSuccess(false);
      }, 5000);
    }

    if ((!PASSWORD_REGEX.test(password) && password !== '') || passwordChangeError) {
      setErrorText('Invalid Password. It must contain at least 8 characters.');
    }
    if (password !== confirmedPassword) {
      setErrorText('Passwords do not match');
    }
  }, [confirmedPassword, passwordChangeError, password, isPasswordChangeLoading]);

  return (
    <div className="col px-0">
      <div className="field-container px-2 mb-5">
        <div className="panel theme-gradient-2 py-1 px-2 flex aic mb-3">
          <h2 className="f-14 white">SECURITY</h2>
        </div>
        {/* <div className="row">
          <div className="col-12 pr-1">
            <p>
              These preferences will only be applied to you. For account security settings please go to{' '}
              <a href="/settings" className="link green text-underline">
                account defaults
              </a>
              .
            </p>
          </div>
        </div>
        <hr /> */}
        <div className="row">
          <div className="col-6 pr-1">
            <div className="field-container mb-0">
              <label htmlFor="account-new-project-name" className="f-14">
                Change Password
              </label>
              <input
                type="password"
                className="medium-input max-330 mb-1"
                name="password"
                id="new-password"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <input
                type="password"
                className="medium-input max-330 mb-2"
                name="password"
                id="repeat-new-password"
                placeholder="Confirm New Password"
                value={confirmedPassword}
                onChange={(e) => setConfirmedPassword(e.target.value)}
              />
              {password && confirmedPassword && !errorText ? (
                <>
                  <button className="btn btn-md mb-2" onClick={handleChangePassword}>
                    {isPasswordChangeLoading ? (
                      <Loader type="TailSpin" color="var(--theme-primary-color)" height={20} width={20} />
                    ) : (
                      'Update'
                    )}
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="btn btn-md mb-2"
                    style={{ backgroundColor: 'gray', pointerEvents: 'none', marginTop: 10 }}
                  >
                    Update
                  </button>
                </>
              )}
              {isPasswordChangeSuccess && <p style={{ color: 'green' }}> Password updated successfully </p>}

              {errorText && <p style={{ color: 'red' }}> {errorText}</p>}
            </div>
          </div>
        </div>
        {/*
        <hr />
                 <div className="row">
          <div className="col-12 pr-1">
            <div className="field-container mb-0">
              <label htmlFor="GDPR" className="f-14">
                Require Two-factor Authentication (2FA)
              </label>
              <p className="f-10 mb-1 blueGray">Require all users to set up 2FA to log-in..</p>
              <label className="switch big-switch mr-1">
                <input
                  type="checkbox"
                  className="switch-input change-theme"
                  checked={twoFactorAuth}
                  onClick={() => setTwoFactorAuth((prev) => !prev)}
                />
                <span className="switch-label"></span>
                <span className="switch-handle"></span>
              </label>
            </div>
          </div>
        </div> 
        <hr />
        <div className="field-container mb-1">
          <label htmlFor="account-new-project-name" className="f-14">
            Export your whole account in a zip file (.zip)
            <p>
              <small className="f-10 blueGray">
                All of the account’s settings and files will be packed into a ZIP file with any files you might have in
                those boards.
              </small>
            </p>
          </label>
          <a href="/" className="btn btn-md flex-inline darkGray-bg white ml-0">
            <img src="images/upload-icon.png" alt="" className="img-fluid icon-rotated mr-05" /> Export
          </a>
        </div>
        <hr />
        <div className="field-container mb-1">
          <label htmlFor="account-new-project-name" className="f-14">
            Log Out of All Sessions
            <p>
              <small className="f-10 blueGray">
                This will log you out of all devices and sessions, including this active one.
              </small>
            </p>
          </label>
          <button className="btn btn-md flex-inline darkGray-bg white ml-0" onClick={() => dispatch(logOut())}>
            Log Out
          </button>
        </div>
         */}
        <hr />
        <div className="row">
          {/*       <div className="col-6 flex aic">
            <a href="/" className="btn mx-0" title="Save">
              Save
            </a>
          </div> */}
        </div>
      </div>
    </div>
  );
};
